<template>
  <div id="app">
    <div v-if="$route.path.trim().startsWith('/top-sales')" >
      <router-view></router-view>
    </div>
    <div v-else >
      <app-nav v-if="$store.state.user"></app-nav>
      <router-view></router-view>
      <cc-profile></cc-profile>
    </div>
  </div>
</template>

<script>
import Nav from "./components/Nav";
import Profile from "./views/Profile";
import Countries from "./mixins/Countries";
import Socket from "./mixins/Socket";

export default {
  mixins: [Countries, Socket],
  components: {
    'app-nav': Nav,
    'cc-profile': Profile,
  },
  data: function () {
    return {
      refreshing: false,
      registration: null,
      updateExists: false,
    }
  },
  methods: {
    refreshApp() {
      this.updateExists = false;
      if (!this.registration || !this.registration.waiting) {
        return;
      }
      this.registration.waiting.postMessage('skipWaiting');
    },
    showRefreshUI(e) {
      this.registration = e.detail;
      this.updateExists = true;
      if (this.updateExists) {
        this.$swal({
          title: 'New Version',
          text: 'Phonenet have been updated to new version, please confirm to update!',
          icon: "success",
          showCancelButton: true
        }).then((result) => {
          if (result.value) {
            this.refreshApp();
          }
        });
      }
    },
  },
  mounted() {
    document.addEventListener(
        'swUpdated', this.showRefreshUI, {once: true}
    );
    navigator.serviceWorker.addEventListener(
        'controllerchange', () => {
          if (this.refreshing)
            return;
          this.refreshing = true;
          window.location.reload();
        }
    );
    setTimeout(() => {
      const CALLIO_LIVECHAT_API = CALLIO_LIVECHAT_API || window.CALLIO_LIVECHAT_API || null;
      if (CALLIO_LIVECHAT_API && this.$store.state.user) {
        CALLIO_LIVECHAT_API.setAttributes({
          'name': `${this.$store.state.user.name}`,
          'email': `${this.$store.state.user.email}`,
          'hash': `${this.$store.state.user._id}`,
        });
      }
    }, 3000);
  }
};
</script>

<style lang="scss">
@import "./assets/sass/main";
</style>
<style lang="css">
.mx-datepicker-range {
  width: auto!important;
}
</style>



























